// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface TabsStyles {
    wrapper?: InjectableCss;
    tab1?: InjectableCss;
    tab2?: InjectableCss;
    tab3?: InjectableCss;
    tab4?: InjectableCss;
    tab5?: InjectableCss;
    tab6?: InjectableCss;
}

const styles: TabsStyles = {
    wrapper: {
        css: css`
            display: flex;
            position: relative;
            height: 33px;

            & div {
                height: 33px;
                width: 45px;
                border-radius: 0 0 13px 13px;
                position: absolute;
                top: 0;
                transition: all 200ms;
            }

            && div:hover {
                transform: scale(1.1);
            }

            @media (max-width: 550px) {
                margin-bottom: 10px;
            }
        `,
    },
    tab1: {
        css: css`
            background: ${getColor("common.mktg1")};
            right: 120px;
        `,
    },
    tab2: {
        css: css`
            background: ${getColor("common.mktg2")};
            right: 96px;
        `,
    },
    tab3: {
        css: css`
            background: ${getColor("common.mktg3")};
            right: 72px;
        `,
    },
    tab4: {
        css: css`
            background: ${getColor("common.mktg4")};
            right: 48px;
        `,
    },
    tab5: {
        css: css`
            background: ${getColor("common.mktg5")};
            right: 24px;
        `,
    },
    tab6: {
        css: css`
            background: ${getColor("common.mktg6")};
            right: 0;
        `,
    },
};

const ColoredTabs = () => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.tab1}></StyledWrapper>
            <StyledWrapper {...styles.tab2}></StyledWrapper>
            <StyledWrapper {...styles.tab3}></StyledWrapper>
            <StyledWrapper {...styles.tab4}></StyledWrapper>
            <StyledWrapper {...styles.tab5}></StyledWrapper>
            <StyledWrapper {...styles.tab6}></StyledWrapper>
        </StyledWrapper>
    );
};

export default ColoredTabs;
